import { connect } from 'react-redux'
import Adwords from '../Components/Adwords'

const mapStateToProps = state => ({
    storeData: state.data,
})

export default connect(mapStateToProps)(Adwords)